import type { LandingLocale } from './content/landingContentTypes.js';
import { landingLocalizedUrl } from './landingDocumentUrl.js';
import { isPublicLandingPath, landingPageTitle, LANDING_NOT_FOUND_TITLES } from './landingPageSeo.js';
import { PAGE_SEO_DESCRIPTIONS } from './landingSeoDescriptions.js';

export const DEFAULT_LANDING_DESCRIPTION = 'Viva Porta begleitet internationale Fachkräfte und Unternehmen in Deutschland bei Bewerbung, Anerkennung, Einreise und Integration.';

export const resolveLandingDocumentSeo = (origin: string, path: string, locale: LandingLocale, description = '') => ({
  title: landingPageTitle(locale, path) ?? LANDING_NOT_FOUND_TITLES[locale],
  description: PAGE_SEO_DESCRIPTIONS[locale][path as keyof typeof PAGE_SEO_DESCRIPTIONS.de] ??
    (description.replace(/<[^>]*>/gu, ' ').replace(/\s+/gu, ' ').trim() || DEFAULT_LANDING_DESCRIPTION).slice(0, 180),
  canonicalUrl: landingLocalizedUrl(origin, path, locale),
  publicPage: isPublicLandingPath(path),
  alternates: (['de', 'en', 'tr', 'x-default'] as const).map(language => ({
    language,
    href: landingLocalizedUrl(origin, path, language === 'x-default' ? 'de' : language),
  })),
});

export const landingIndexingAllowed = (deployment: unknown): boolean => deployment === 'production';
